export const getHighlightedRecordingId = (state: any) =>
  state.getIn(['core', 'app', 'recordings', 'highlightedRecordingId'], undefined);

export const getShowAllUnseenRecordingStatus = (state: any) =>
  state.getIn(['core', 'app', 'recordings', 'showAllUnseenRecordings'], false);
